(function (upp) {
    'use strict';

    upp.directive('modalChangePasswordTpl', ['$timeout', 'restoreService',
        function ($timeout, restoreService) {
            var modal,
                token,
                _changePassword = function (scope) {
                    restoreService.changePassword(scope['password'], token)
                        .then(function () {
                            scope.changeError = false;
                            scope.changeSuccess = true;

                            $timeout(function () {
                                modal.modal('hide');
                            }, 2000);
                        }, function () {
                            scope.restoreError = true;
                        });
                },
                _resetModel = function (scope) {
                    scope.changeError = false;
                    scope.changeSuccess = false;
                    scope.password = '';
                    scope.passwordRepeat = '';
                };

            return {
                restrict: 'E',
                replace: true,
                templateUrl: require('../templates/modal-change-password-tpl.html'),
                controller: ['$scope', function ($scope) {
                    $scope.email = '';

                    $scope.changePassword = function () {
                        _changePassword($scope);
                    };
                }],
                link: function (scope, element) {
                    // open the modal
                    scope.$on('changePasswordModal:open', function (event, args) {
                        // FIXME: Having multiple modals shown cause them to block each other
                        // when requesting for focus and causes a recurence error leaving both
                        // unresponsive. To fix this we hide any existent modal until the
                        // password closes. This is a temp fix until modals get properly reworked
                        var styleOverride = $('<style>')
                            .appendTo($('head'))
                            .text('.modal:not(#' + element.attr('id') + ') { display: none }')

                        modal = modal || element;
                        token = args['token'];

                        _resetModel(scope);
                        scope.email = '';
                        modal.modal('show');
                        modal.one('shown', function () {
                            $('#password, #repeat-password').unbind('mouseup mousedown');
                        });

                        // send event
                        modal.one('hidden', function () {
                            $timeout(function () {
                                scope.$broadcast('changePasswordModal:close');
                            }, 500);

                        });

                        // submit with ENTER key
                        modal.unbind('keypress').bind('keypress', function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                _changePassword(scope);
                            }
                        });

                        // close the modal
                        scope.$on('changePasswordModal:close', function () {
                            styleOverride.remove(); // FIXME: See note on styleOverride declaration
                            modal.modal('hide');
                        });
                    });
                }
            }
        }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/login/directives/modal-change-password-tpl_directive.js